import * as types from './Types.js';

const initialState = {
  integradoUnico: false,
  usaProcessoExterno: false,
  usaOuvidoria: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CONFIG_SUCCESS: {
      return {
        ...action.payload
      };
    }

    default: {
      return state;
    }
  }
}
